import * as React from 'react';
import GoogleMapReact from 'google-map-react';

import {getFramework7} from './App';


const ReactMapIcon = React.createClass({
    render: function () {
        return <div style={{position: 'relative', left: "-15px", top: "-40px"}}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" className="building-icon" onClick={this.props.clickHandler}>
                <path fill="#606162"
                      d="M24 0c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z"/>
                <circle fill="#FFFFFF" cx="24" cy="20" r="10"/>
            </svg>
            <label style={{textAlign: 'center', top: '11px', width: '40px', position: 'absolute', pointerEvents: 'none'}}>{this.props.index}</label>
        </div>
    }
});

const UsrIcon = () => (
		<div style={{position: 'relative', left: "-5px", top: "-5px"}}>
			<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
				<circle fill="#007aff" cx="5" cy="5" r="5"/>
			</svg>
		</div>
);


export class MapDisplay extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
		    startingPositionSet: false,
		    startingLat: 41.585013,
            startingLng: -93.624471
        }
	}

	componentDidMount() {
		var locationWatch = navigator.geolocation.watchPosition(
				this.onUserPositionChanged.bind(this),
				this.onUserPositionError.bind(this), {timeout: 30000, enableHighAccuracy: true});

		this.setState({locationWatch: locationWatch})
	}

	componentWillUnmount() {
		if (this.state.locationWatch != null) {
			navigator.geolocation.clearWatch(this.state.locationWatch);
		}
	}

	onUserPositionChanged(position)
	{
        if (!this.state.startingPositionSet) {
            this.setState({
                startinglat: position.coords.latitude,
                startingLng: position.coords.longitude,
                startingPositionSet:true
            });
        }
		this.setState({
			userLat: position.coords.latitude,
			userLng: position.coords.longitude
		});
	}

	onUserPositionError(error)
	{
		// alert('code: ' + error.code + '\n' + 'message: ' + error.message + '\n');
	}

	render() {
		if (this.props.config === undefined) {
			return <div />;
		}

		let icons = [];
		var showNumbers = this.props.showNumbers;

		this.props.buildings.forEach(function (building, index)
		{
            icons.push(<ReactMapIcon
                key={building.slug + '-icon'}
                lat={building.lat}
                lng={building.lng}
                index={showNumbers ? index + 1 : ""}
                clickHandler={function(_) {
                    getFramework7().popup(".popup-" + building.slug)
                }}
            />);
		});

        icons.push(<UsrIcon key="userIcon" lat={this.state.userLat} lng={this.state.userLng}/>);


        return (
                <GoogleMapReact
					key="mapDisplay"
                    bootstrapURLKeys={{key: this.props.config.mapApiKey}}
                    center={{lat: this.state.startingLat, lng: this.state.startingLng}}
                    zoom={16}
                    style={this.props.style}>
                    {icons}

                </GoogleMapReact>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/MapDisplay.jsx